$(document).on("turbo:load", () => {
  // Timezone handling logic
  const timezoneInput = $("input.timezone[data-default-from-locale]");

  if (timezoneInput.length > 0 && window.Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone) {
    timezoneInput.val(Intl.DateTimeFormat().resolvedOptions().timeZone);
  }
  
  // Marketing emails checkbox handling logic
  const checkbox = $("#user_subscribed_to_marketing_emails");
  const hiddenFields = $(".sso_signup_form_marketing_emails_hidden");

  if (checkbox.length && hiddenFields.length) {
    function updateHiddenFields() {
      const isChecked = checkbox.prop("checked") ? "1" : "0";
      hiddenFields.each(function() {
        $(this).val(isChecked);
      });
    }
    
    checkbox.on("change", updateHiddenFields);
    updateHiddenFields();
  }
}); 
